<template>
  <div class="map-page">
    <!--<div @mouseenter="mapFlase()">-->
    <!--<div>-->
    <top-map :backBool="backBool"
             :map-list-click-bool="mapListClickBool"
             :no-data-bool="noDataBool"
             @mapBool="mapBoolVal"
             @industryCity="industryCityVal"></top-map>
    <!--</div>-->
    <div class="map-content" :class="[backBool?'map-content-all':'']">
      <div @mouseenter="mapFlase()" class="map-content-left animated fadeInLeft">
        <div class="icon-map-back " @click="mapBack"><i class="icon-img"></i></div>
        <div class="map-list-content">
          <div class="map-tab">
            <span :class="[tabIndex==0?'active':'']" @click="panList('PanoWebService.asmx/GetRecommendByCity',0)">推荐</span>
            <span :class="[tabIndex==1?'active':'']" @click="panList('PanoWebService.asmx/GetLatestByCity',1)">最新</span>
            <span v-if="industryName" :class="[tabIndex==2?'active':'']" @click="panList('industry',2)">{{industryName}}</span>
          </div>
          <div class="map-list max-con">
            <template v-if="lists&&lists.length">
                <ul>
                <template v-for="(item, index) in lists">
                  <li :class="['list animated fadeInLeft',(activeIndex==index?'active':'')]" :key="'map-list-content'+index" @click="addressPunctuation(index)">
                    <div class="posRe">
                      <div class="list-img" :style="'backgroundImage:url('+item.imgSrc+');'"><span class="icon-img img-list-see"></span></div>
                      <div class="list-content">
                        <h3 class="oneRow" :title="item.name">{{item.name}}</h3>
                        <p class="oneRow">地址：{{item.address || '更新中'}}</p>
                        <p class="oneRow">电话：{{item.phone || '暂无'}}</p>
                        <div>
                          <span class="img-good"><i class="icon-img"></i>{{item.good}}</span>
                          <span class="img-share"><i class="icon-img"></i>{{item.share}}</span>
                        </div>
                      </div>
                    </div>
                  </li>
                </template>
              </ul>
              <div v-show="loadingBool" id="related"><div class="loading"><i class="myicon icon-loading-1 load-icon"></i><span>加载中……</span></div></div>
            </template>
            <template v-else>
              <transition leave-active-class="">
                <div class="no-data"><span>暂无数据</span></div>
              </transition>
            </template>
          </div>
        </div>
      </div>
      <div id="mapDiv" v-if="mapShow" class="animated fadeInRight" @mouseenter="mapTrue()">
        <div id="mousePosition"></div>
        <div id="leftNavData" style="">
        </div>
      </div>
    </div>
    <div :class="[loadingData?'is-loading':'']">
      <div class="curtain">
        <div class="loader">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import topMap from '@/components/topMap.vue'
import mapFun from '../../common/map.js'
export default {
  name: 'mapPage',
  inject: ['reload'],
  data () {
    return {
      params: {
        cityId: 0,
        typeId: 0,
        page: 1,
        limit: 10
      },
      state: 2,
      lists: [],
      activeIndex: -1,
      tabIndex: 0,
      url: '',
      total: 0,
      page: 1,
      loadingBool: false,
      pageRefreshBool: false,
      tabClickBool: true,
      backBool: false,
      tabBool: false,
      noDataBool: false,
      industryName: '',
      industryLists: [],
      limit: 10,
      mapListClickBool: false,
      loadingData: true,
      mapShow: false
    }
  },
  components: {
    topMap: topMap
  },
  created () {
    let that = this;
    that.mapShow = true;
    let routeQuery = JSON.parse(that.publicJs.decode(that.$route.query)) || {};
    that.params.cityId = routeQuery.cityId || 0;
    that.params.typeId = routeQuery.typeId || 0;
    that.pageRefreshBool = routeQuery.bool;
    this.$emit('topState', 3)
  },
  mounted () {
    if (this.tabClickBool) {
      this.listScrollb()
    }
  },
  methods: {
    mapFlase: function () {
      this.mapListClickBool = true
    },
    mapTrue: function () {
      this.mapListClickBool = false
    },
    industryCityVal: function (industryVal, cityVal, bool, num) {
      let that = this;
      if (!that.mapListClickBool || num >= 1) {
        that.tabIndex = 2;
        that.page = 1;
        that.lists = [];
        that.url = 'industry';
        that.activeIndex = -1;
        that.industryName = industryVal && industryVal.name ? industryVal.name : '全部'
        that.loadingData = true;

        that.mapSearchInit(industryVal, cityVal, bool)
      }
    },
    mapBoolVal: function (val) {
      this.mapListClickBool = val
    },
    mapSearchInit: function (industryVal, cityVal, bool) {

      let that = this;
      let nowCityVal = (cityVal || {cityId: 0, x: 102.55879281894, y: 31.121115892911, mapLevel: 6});
      that.httpAjax.getAjax('PanoWebService.asmx/GetPanoByWhere_Map', {
        page: 1,
        cityId: nowCityVal.cityId >= 0 ? nowCityVal.cityId : 0,
        limit: 10000,
        typeId: industryVal && industryVal.id >= 0 ? industryVal.id : 0,
        keyWords: ''
      }).then(function (data) {
        if (data.code === 1) {
          if (!data.total) {
          }
          that.total = data.total;
          let newData = JSON.parse(JSON.stringify(data.data));
          if (newData && newData.length === 0) {
            that.noDataBool = true;
            setTimeout(function () {
              that.noDataBool = false
            }, 1500)
          }
          setTimeout(function () {
            that.loadingData = false
          }, 500);
          if (bool) {
            // eslint-disable-next-line
            MAP.map.centerAndZoom(new T.LngLat(nowCityVal.x, nowCityVal.y), nowCityVal.mapLevel);
          }
          that.industryLists = newData && newData.length ? that.publicJs.newList(JSON.parse(JSON.stringify(newData)), that.limit) : [];
          mapFun.ShowSearchPoint(newData, true);
          that.industryLoading(1)
        }
      }, function (err) {
        console.log(err)
      })
    },
    panList: function (url, index, bool) {
      let that = this;
      if (that.url !== url) {
        that.lists = [];
        that.url = url;
        that.tabIndex = index;
        that.page = 1;
        that.params.page = 1;
        that.tabClickBool = (bool || false);
        that.tabBool = (bool || false);
        if (url === 'industry') {
          that.industryLoading(1)
        } else {
          that.httpData(1)
        }
      }
    },
    httpData: function (page) {
      let that = this;
      that.params.page = page;
      mapFun.mapFun(that.url, that.params, that.pageRefreshBool).then(function (res) {
        if (res.code === 1) {
          that.total = res.total;
          let newData = JSON.parse(JSON.stringify(res.data));
          that.lists = that.lists.concat(newData);
          that.loadingBool = false;
          that.tabClickBool = true
        }
      })
    },
    industryLoading: function (page) {
      let that = this;
      that.lists = that.industryLists && that.industryLists.length ? that.lists.concat(that.industryLists[page - 1]) : [];
      that.loadingBool = false;
      that.tabClickBool = true
    },
    addressPunctuation: function (i) {
      let that = this;
      that.mapListClickBool = true;
      that.activeIndex = i;
      mapFun.addressSite(that.lists[i])
    },
    listScrollb: function () {
      var that = this;
      $('.map-list').scroll(function (e) {
        if (!that.loadingBool) {
          if (that.publicJs.isScrollBottom(this)) {
            // 滚动到底端了 加载内容
            // 加载数据
            that.tabBool = true;
            let p = that.page;
            let l = that.params.limit;
            that.loadingBool = true;
            if (p && l && (p * l < that.total)) {
              setTimeout(function () {
                that.page++;
                if (that.url === 'industry') {
                  that.industryLoading(that.page)
                } else {
                  that.httpData(that.page)
                }
                that.tabClickBool = false
              }, 240)
            } else {
              that.loadingBool = false
            }
          }
        }
      })
    },
    mapBack: function () {
      this.backBool = !this.backBool
    }
  },
  computed: {
  },
  watch: {
    '$route': {
      handler: function (a, b) {
        let that = this;
        if (a !== b) {
          that.lists = [];
          let c = JSON.parse(that.publicJs.decode(that.$route.query)) || {};
          that.params.cityId = c.cityId;
          that.params.typeId = c.typeId;
          this.reload()
        }
      },
      deep: true
    }
  },
  beforeDestroy(){
    this.$root.panIndex=this.panActiveIndex;
    if(this.timer){
      clearInterval(this.timer)
    }
  },
  destroyed () {
    this.mapShow = false
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import "../../../static/js/Map/css/map_css.css";
  @import "../../../static/js/Map/ol/ol.css";
  .map-content{
    position: absolute;
    top:90px;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .map-content-left{
    position: absolute;
    left: 0;
    bottom: 0;
    top:0;
    width:380px;
    z-index: 7;
  }
  .map-list-content{
    position: absolute;
    left: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding:16px 20px;
    -webkit-box-shadow:2px 5px 13px 1px rgba(221, 221, 221, 0.56);
    -moz-box-shadow:2px 5px 13px 1px rgba(221, 221, 221, 0.56);
    box-shadow:0 5px 13px 1px #b7b7b3;
    background: #FAFAFA;
    overflow: hidden;
    -webkit-transition: left 0.5s;
    -moz-transition: left 0.5s;
    -ms-transition: left 0.5s;
    -o-transition: left 0.5s;
    transition: left 0.5s;
  }
  .map-content-all .map-list-content{
    left: -380px;
  }
  .map-content-all .icon-map-back{
    left: 0;
  }
  .map-content-all .icon-map-back i{
    background-position: -739px -424px;
  }
  .icon-map-back{
    position: absolute;
    left: 380px;
    top:50%;
    z-index: 8;
    width: 20px;
    height: 84px;
    margin-top: -42px;
    background: #FAFAFA;
    border-radius: 0px 20px 20px 0px;
    -webkit-box-shadow: 0px 0px 13px 0 #b7b7b3;
    -moz-box-shadow: 0px 0px 13px 0 #b7b7b3;
    box-shadow: 0px 0px 13px 0 #b7b7b3;
    -webkit-transition: left 0.5s;
    -moz-transition: left 0.5s;
    -ms-transition: left 0.5s;
    -o-transition: left 0.5s;
    transition: left 0.5s;
  }
  .icon-map-back>i{
    position: absolute;
    width: 10px;
    height: 10px;
    top:50%;
    margin-top: -5px;
    left: 5px;
    background-position:-707px -423px;
  }
  .map-tab{
    position: relative;
    font-size: 14px;
    color: #666666;
    line-height: 18px;
  }
  .map-tab>span{
    margin-right: 22px;
    cursor: pointer;
    display: inline-block;
  }
  .map-tab>span.active{
    font-size: 18px;
    color: #248DDF;
  }
  .map-list{
    position: absolute;
    top:50px;
    left: 20px;
    right: 5px;
    bottom: 0;
    overflow-y: auto;
  }
  #mapDiv{
    position: absolute;
    top:0;
    left: 400px;
    right: 0;
    bottom: 0;
    overflow: hidden;
    z-index: 6;
    /*-webkit-transform: translateX(380px);
    -moz-transform: translateX(380px);
    -ms-transform: translateX(380px);
    -o-transform: translateX(380px);
    transform: translateX(380px);*/
    -webkit-transition: transform 0.5s;
    -moz-transition: transform 0.5s;
    -ms-transition: transform 0.5s;
    -o-transition: transform 0.5s;
    transition: transform 0.5s;
  }
  .map-content-all #mapDiv{
    left: 0;
    /*-webkit-transform: translateX(0);
    -moz-transform: translateX(0);
    -ms-transform: translateX(0);
    -o-transform: translateX(0);
    transform: translateX(0);*/
  }
  #mousePosition {
    position: absolute;
    left: 120px;
    bottom: 34px;
    z-index: 9999;
    font-size: 12px;
  }
  .no-data{
    width: 100%;
    height: 100%;
    background-size: 90%;
    background-position:center 25%;
    position: relative;
  }
  .no-data span{
    position: absolute;
    text-align: center;
    width: 100%;
    top:45%;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/page/map/index.vue